// src/stores/authToken.store.ts
//
// Refresh token은 백엔드가 Set-Cookie(HttpOnly)로 관리합니다.
// 이 스토어는 access token만 관리합니다.
import { create } from "zustand";

type AuthTokenState = {
  accessToken: string | null;
  /** access token만 갱신 */
  setAccessToken: (accessToken: string | null) => void;
  /**
   * 소셜 로그인/일반 로그인 후 토큰 저장.
   * refreshToken 인자는 무시됩니다 — HttpOnly 쿠키로 백엔드가 관리합니다.
   */
  setTokens: (accessToken: string | null, _refreshToken?: string | null) => void;
  clearTokens: () => void;
  hydrateFromStorage: () => void;
};

const ACCESS_KEY = "korehalal_access_token";

export const authTokenStore = create<AuthTokenState>((set) => ({
  accessToken: null,

  setAccessToken: (accessToken) => {
    set({ accessToken });
    if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
    else localStorage.removeItem(ACCESS_KEY);
  },

  setTokens: (accessToken, _refreshToken) => {
    set({ accessToken });
    if (accessToken) localStorage.setItem(ACCESS_KEY, accessToken);
    else localStorage.removeItem(ACCESS_KEY);
    // refreshToken은 Set-Cookie(HttpOnly)로 브라우저가 자동 관리합니다.
  },

  clearTokens: () => {
    set({ accessToken: null });
    localStorage.removeItem(ACCESS_KEY);
    // 쿠키 삭제는 백엔드 /logout API가 Set-Cookie: refresh_token=; Max-Age=0 으로 처리합니다.
  },

  hydrateFromStorage: () => {
    const accessToken = localStorage.getItem(ACCESS_KEY);
    set({ accessToken: accessToken ?? null });
  },
}));
